import {Component, ElementRef, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {HelpInformationService} from "../../../core/services/help-information.service";

@Component({
    selector: 'app-help-information',
    templateUrl: './help-information.component.html',
    styleUrls: ['./help-information.component.scss'],
    standalone: false
})
export class HelpInformationComponent implements OnInit {
  @ViewChild('origin') originTemplate?: ElementRef<Component>;
  @ViewChild('popup') popupTemplate?: TemplateRef<Component>;

  constructor(
    private vcRef: ViewContainerRef,
    private helpInformationService: HelpInformationService,
  ) { }

  ngOnInit(): void {
  }

  mouseEnter(): void {
    this.helpInformationService.show(this.originTemplate!, this.popupTemplate!, this.vcRef);
  }

  mouseLeave(): void {
    this.helpInformationService.hide();
  }
}
